import { Sections } from "PFApp/types/activity_form/activity_form_schema";
import { Card } from "PFComponents/card";
import { Stack } from "PFComponents/containers";
import { Cover } from "PFComponents/cover";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import css from "../activity_form.module.scss";
import { useVisibleSections } from "../hooks/use_visible_sections";
import { FormPlaceholderMessage } from "./form_placeholder";

export const FormBody = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form" });

  const visibleSections = useVisibleSections();
  const showPlaceholder = visibleSections.length === 1 && visibleSections[0].id === Sections.Subtemplate;

  const {
    formState: { isSubmitting }
  } = useFormContext();

  return (
    <Stack className={css.formHorizontalScroll}>
      <Stack className={css.formBody} gap="spacingLg">
        {isSubmitting && <Cover />}
        {visibleSections.map(({ id, title, component: SectionComponent }) => (
          <SectionComponent key={title} id={id} title={title} />
        ))}
        {showPlaceholder && (
          <Card className={css.formPlaceholder} shadowVariant="none">
            <FormPlaceholderMessage message={t("placeholder")} />
          </Card>
        )}
      </Stack>
    </Stack>
  );
};
